import { render, staticRenderFns } from "./SafeTask.vue?vue&type=template&id=6d0f4e58&scoped=true&"
import script from "./SafeTask.vue?vue&type=script&lang=js&"
export * from "./SafeTask.vue?vue&type=script&lang=js&"
import style0 from "./SafeTask.vue?vue&type=style&index=0&id=6d0f4e58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f4e58",
  null
  
)

export default component.exports